export default __webpack_public_path__ + "static/media/Panzanella Salad - proportioned_170.c61aa0a9.jpg";